import { DateTime } from 'luxon';
import * as z from 'zod';

/**
 * Validates a date string against a specified timezone and format.
 * @param {string} timezone - The timezone to use for parsing the date.
 * @param {string} format - The format string to use for parsing the date, e.g. 'M/d/yyyy HH:mm:ss'.
 * @returns {(val: string, ctx: import('zod').RefinementCtx)} - A Zod custom validation function that checks if the date is valid.
 */
export function validDate(timezone, format) {
  return (val, ctx) => {
    const parsed = DateTime.fromFormat(val, format, {
      zone: timezone,
    });
    if (!parsed.isValid) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: `Invalid timestamp format or value: ${
          parsed.invalidExplanation || 'Unknown error'
        }`,
      });
      return z.NEVER;
    }
    return parsed.toUTC().toISO(); // Return the date in ISO format
  };
}
